import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-scroll'
import saasWatchDesktopImg from '../../images/logo/saaswatch desktop.png';

const Hero6 = () => {
    return (
        <section className="hero-gradient-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', paddingTop: '120px', paddingBottom: '80px' }}>
            {/* Animated Gradient Orbs */}
            <div className="gradient-orb gradient-orb-1"></div>
            <div className="gradient-orb gradient-orb-2"></div>
            <div className="gradient-orb gradient-orb-3" style={{ width: '250px', height: '250px', top: '20%', left: '60%' }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row align-items-center">
                    <div className="col-12 col-lg-6 col-xl-6">
                        <div className="xb-hero">
                            {/* Floating Badge */}
                            <Fade direction='down' triggerOnce={true} duration={800}>
                                <div style={{ marginBottom: '24px' }}>
                                    <span className="badge-outline" style={{ background: 'rgba(59, 130, 246, 0.15)', borderColor: 'rgba(59, 130, 246, 0.4)', color: '#93c5fd' }}>
                                        <span style={{ width: '8px', height: '8px', background: '#3b82f6', borderRadius: '50%', display: 'inline-block', marginRight: '8px', animation: 'pulse-glow 2s ease-in-out infinite' }}></span>
                                        Now Available
                                    </span>
                                </div>
                            </Fade>

                            {/* Hero Title */}
                            <Fade direction='up' triggerOnce={true} duration={1000} delay={100}>
                                <div>
                                    <h1 className="hero-title-gradient" style={{ marginBottom: '24px' }}>
                                        Take Control of Your <span className="highlight">SaaS Spend</span>
                                    </h1>
                                </div>
                            </Fade>

                            {/* Hero Subtitle */}
                            <Fade direction='up' triggerOnce={true} duration={1000} delay={200}>
                                <div>
                                    <p style={{ fontSize: '1.25rem', color: 'rgba(255, 255, 255, 0.7)', lineHeight: '1.8', marginBottom: '16px', maxWidth: '500px' }}>
                                        Analyze, manage, and optimize your SaaS subscriptions. Get complete visibility into your cloud costs and save up to 30%.
                                    </p>
                                </div>
                            </Fade>

                            {/* Feature List */}
                            <Fade direction='up' triggerOnce={true} duration={1000} delay={300}>
                                <div>
                                    <ul style={{ listStyle: 'none', padding: 0, marginBottom: '40px' }}>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(255, 255, 255, 0.8)', marginBottom: '12px' }}>
                                            <span style={{ width: '20px', height: '20px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                            Easily integrate your SaaS vendors
                                        </li>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(255, 255, 255, 0.8)' }}>
                                            <span style={{ width: '20px', height: '20px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                            Manage contracts and contacts
                                        </li>
                                    </ul>
                                </div>
                            </Fade>

                            {/* Dual CTA Buttons */}
                            <Fade direction='up' triggerOnce={true} duration={1000} delay={400}>
                                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                    <Link
                                        to="contact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        className="btn-gradient"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Get Started
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </Link>
                                    <Link
                                        to="funfact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-100}
                                        className="btn-ghost-white"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
                                            <path d="M10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6024 1.66669 10 1.66669C5.39765 1.66669 1.66669 5.39765 1.66669 10C1.66669 14.6024 5.39765 18.3334 10 18.3334Z" stroke="currentColor" strokeWidth="1.5"/>
                                            <path d="M8.33331 7.5L13.3333 10L8.33331 12.5V7.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Watch Demo
                                    </Link>
                                </div>
                            </Fade>
                        </div>
                    </div>

                    {/* Hero Image */}
                    <div className="col-12 col-lg-6 col-xl-6 mt-5 mt-lg-0">
                        <Fade direction='right' triggerOnce={true} duration={1200} delay={300}>
                            <div className="float-animation-slow" style={{ textAlign: 'center' }}>
                                <div style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '24px',
                                    padding: '20px',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    boxShadow: '0 30px 80px rgba(0, 0, 0, 0.3)'
                                }}>
                                    <img
                                        src={saasWatchDesktopImg}
                                        alt="SaaS Watch Dashboard"
                                        style={{
                                            maxWidth: '100%',
                                            height: 'auto',
                                            borderRadius: '16px'
                                        }}
                                    />
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero6;
